import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from 'components/so5/Rules/types';
import { getCompetitionPictureUrl } from 'lib/so5';

import { getNotDomesticCompetitionsRule_so5Rules } from './__generated__/getNotDomesticCompetitionsRule.graphql';

export const getNotDomesticCompetitionsRule = withFragments(
  (
    rules: getNotDomesticCompetitionsRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.notDomesticCompetitions;
    if (!rule?.length) {
      return null;
    }

    return {
      id: 'notDomesticCompetitions',
      label: (
        <FormattedMessage
          id="Rules.notDomesticCompetitions"
          defaultMessage="Players not permitted from"
        />
      ),
      description: (
        <Vertical as="span" gap={0}>
          {rule.map(competition => {
            const competitionPictureUrl = getCompetitionPictureUrl(competition);

            return (
              <Horizontal key={competition.slug} as="span">
                {competitionPictureUrl && (
                  <img
                    src={competitionPictureUrl}
                    alt=""
                    width="16"
                    height="16"
                  />
                )}
                {competition.displayName}
              </Horizontal>
            );
          })}
        </Vertical>
      ),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_7891_228971)">
            <path
              d="M2.125 7.35742V3.74182L8 1.22396L13.875 3.74182V7.35742C13.875 9.82456 12.553 12.1025 10.411 13.3266L8 14.7043L5.58905 13.3266C3.44697 12.1025 2.125 9.82456 2.125 7.35742Z"
              fill="#101010"
              stroke="var(--c-red-600)"
              strokeWidth="2.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 11.5L13.5 4"
              stroke="var(--c-red-600)"
              strokeWidth="2.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_7891_228971">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getNotDomesticCompetitionsRule_so5Rules on So5Rules {
        id
        notDomesticCompetitions {
          slug
          displayName
          ...getCompetitionPictureUrl_competition
        }
      }
      ${getCompetitionPictureUrl.fragments.competition}
    ` as TypedDocumentNode<getNotDomesticCompetitionsRule_so5Rules>,
  }
);
